import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=98c6dbb2&scoped=true&"
import script from "./AddModal.vue?vue&type=script&lang=js&"
export * from "./AddModal.vue?vue&type=script&lang=js&"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=98c6dbb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c6dbb2",
  null
  
)

export default component.exports